<template>
  <fh-container justify-center>
    <v-alert
      :value="!temporada.temporadaHabilitada"
      type="warning"
      class="mb-4"
    >
      La temporada seleccionada fue deshabilitada. No podrá modificar los datos
      de las fichas y actividades de esta temporada.
    </v-alert>

    <template v-if="isConfiguracionMissing">
      <h3 class="headline text-center my-3">Configuración</h3>

      <v-alert :value="temporada.temporadaHabilitada" type="info">
        Cargue algunos datos de configuración para poder continuar con el
        ingreso de actividades en el establecimiento.
      </v-alert>

      <v-row>
        <v-col v-if="isInventarioMissing" cols="12" md="6">
          <v-card :to="{ name: 'Maquinas' }" class="pa-3">
            <v-card-title>
              <v-icon class="pr-3">fa-tractor</v-icon>
              <span class="headline"> Máquinas </span>
            </v-card-title>
          </v-card>
        </v-col>

        <v-col v-if="isPersonalMissing" cols="12" md="6">
          <v-card :to="{ name: 'Personal' }" class="pa-3">
            <v-card-title>
              <v-icon class="pr-3">fa-users</v-icon>
              <span class="headline"> Personal </span>
            </v-card-title>
          </v-card>
        </v-col>

        <v-col v-if="isParcelaConfigMissing" cols="12" md="6">
          <v-card :to="{ name: 'ConfiguracionEstablecimientos' }" class="pa-3">
            <v-card-title>
              <v-icon class="pr-3">fa-cogs</v-icon>
              <span class="headline"> Explotación ganadera </span>
            </v-card-title>
          </v-card>
        </v-col>
      </v-row>
    </template>

    <template v-else>
      <h3 class="text-h4 text-md-center">Actividades</h3>

      <v-row class="my-1">
        <v-col cols="12" md="6" class="pb-0">
          <v-card :to="{ name: 'MovimientosGanaderos' }" class="pa-md-3">
            <v-card-title>
              <v-icon class="pr-3">fa-exchange-alt</v-icon>
              <span class="headline"> Movimientos de ganado </span>
            </v-card-title>
          </v-card>
        </v-col>
        <v-col cols="12" md="6" class="pb-0">
          <v-card :to="{ name: 'Prenez' }" class="pa-md-3">
            <v-card-title>
              <v-icon class="pr-3">{{ prenezIcon }}</v-icon>
              <span class="headline"> Preñez </span>
            </v-card-title>
          </v-card>
        </v-col>
        <v-col
          v-for="concepto in listaFiltradaConceptos"
          :key="concepto.idConcepto"
          cols="12"
          md="6"
          class="pb-0"
        >
          <v-card
            :to="{
              name: 'Movimiento',
              params: { conceptoSlug: concepto.conceptoSlug },
            }"
            class="pa-md-3"
          >
            <v-card-title>
              <span class="headline">
                {{ concepto.nombre }}
              </span>
            </v-card-title>
          </v-card>
        </v-col>
      </v-row>
    </template>
  </fh-container>
</template>

<script>
import FhContainer from "@/components/FhContainer";
import { mapActions, mapState, mapGetters } from "vuex";
import { mdiReproduction } from "@mdi/js";

export default {
  name: "GanaderiaHome",
  components: { FhContainer },
  data() {
    return {
      configuracionList: [
        { title: "Máquinas", icon: "fa-tractor", route: "Maquinas" },
        { title: "Personal", icon: "fa-users", route: "Personal" },
      ],
      listaConceptosFiltrados: [],
      prenezIcon: mdiReproduction,
    };
  },
  watch: {
    updateAgricultorLists: async function (value) {
      if (value === true) {
        await this.fetchListas();
        await this.setUpdateAgricultorListsFalse();
      }
    },
  },
  computed: {
    ...mapState("temporada", ["temporada"]),
    ...mapState("maquinas", ["listaInventario"]),
    ...mapState("personal", ["listaPersonal"]),
    ...mapState("fichas", ["fichaGanadera", "parcelas"]),
    ...mapState("agricultor", ["updateAgricultorLists"]),
    ...mapState("conceptos", ["conceptos"]),
    ...mapGetters("conceptos", ["listaFiltradaConceptos"]),
    isInventarioMissing() {
      return this.listaInventario.length === 0;
    },
    isPersonalMissing() {
      return this.listaPersonal.length === 0;
    },
    isParcelaConfigMissing() {
      return this.parcelas.length === 0;
    },
    isConfiguracionMissing() {
      return (
        this.isInventarioMissing ||
        this.isPersonalMissing ||
        this.isParcelaConfigMissing
      );
    },
  },
  methods: {
    ...mapActions("maquinas", ["fetchListaInventario"]),
    ...mapActions("personal", ["fetchListaPersonal"]),
    ...mapActions("fichas", ["fetchFichaGanadera"]),
    ...mapActions("agricultor", ["setUpdateAgricultorListsFalse"]),
    ...mapActions("conceptos", [
      "fetchListaConceptos",
      "fetchListaSubConceptos",
    ]),
    async fetchListas() {
      // let listaConceptos = this.fetchListaConceptos()
      let listaInventario = this.fetchListaInventario();
      let listaPersonal = this.fetchListaPersonal();
      // let listaSubconceptos = this.fetchListaSubConceptos()

      // await listaConceptos
      // await listaSubconceptos
      await listaInventario;
      await listaPersonal;
      await this.fetchFichaGanadera();
      if (
        (Array.isArray(this.fichaGanadera) &&
          this.fichaGanadera.length === 0) ||
        this.fichaGanadera === null ||
        this.fichaGanadera.idFichaGanadera === null
      ) {
        this.$router.push({ name: "FaltaFichaGanadera" }).catch(() => {});
      }
    },
  },
  async created() {
    await this.fetchListas();
  },
};
</script>
